import ThreeByOneWidget, {
  ThreeByOnePodcastInfo,
  ThreeByOneWidgetProps,
} from 'components/ThreeByOneWidget';
import WidgetHeader, { WidgetHeaderProps } from 'components/WidgetHeader';
import Player from './Player';
import Unit, { UnitProps } from './Unit';
import UnitsContainer from './UnitsContainer';

const Header = WidgetHeader;
const PodcastInfo = ThreeByOnePodcastInfo;
const Widget = ThreeByOneWidget;

const components = {
  Player,
  Unit,
  Header,
  PodcastInfo,
  UnitsContainer,
  Widget,
};

export { Player, Unit, Header, PodcastInfo, UnitsContainer, Widget };

export type {
  UnitProps,
  ThreeByOneWidgetProps as WidgetProps,
  WidgetHeaderProps as HeaderProps,
};

export default components;
